<template>
  <div class="box">
    <el-select
      v-model="form.platform"
      class="box-platform"
      @change="platformChange"
    >
      <el-option v-if="showAll" label="全部" value=""></el-option>
      <el-option
        v-for="item in platformList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-select
      v-model="form.sellerManageId"
      class="box-shop"
      @change="shopChange"
    >
      <el-option v-if="showAll" label="全部" value=""></el-option>
      <el-option
        v-for="item in shopList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    shopData: {
      type: Array,
      default: () => [],
    },
    showAll: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        platform: "",
        sellerManageId: "",
      },
      shopList: [],
      isFirst: true,
    };
  },
  computed: {
    platformList() {
      let list = [];
      if (this.shopData.length) {
        const shopPlatform = this.shopData.map((item) => Number(item.platform));
        list = this.$platformList.filter((item) =>
          shopPlatform.includes(item.value)
        );
      }
      if (list.length && this.defaultValue && this.isFirst) {
        this.isFirst = false;
        const platform = list[0].value;
        this.form.platform = platform;
        const shopList = this.shopData.filter(
          (item) => item.platform == platform
        );
        if (shopList.length) {
          const shop = shopList[0].value;
          this.form.sellerManageId = shop;
          this.shopList = shopList;
          this.shopChange(shop);
          this.$emit("init");
        }
      }
      return list;
    },
  },
  methods: {
    platformChange(e) {
      this.shopList = this.shopData.filter((item) => item.platform == e);
      if (this.showAll) {
        this.form.sellerManageId = "";
      } else {
        this.form.sellerManageId = this.shopList.length
          ? this.shopList[0].value
          : "";
      }
      this.$emit("platformChange", e);
      this.shopChange(this.form.sellerManageId);
    },
    shopChange(e) {
      this.$emit("change", this.form.platform, e);
    },
    reset() {
      if (this.showAll) {
        this.form.platform = "";
        this.form.sellerManageId = "";
      } else {
        if (this.platformList.length) {
          const platform = this.platformList[0].value;
          this.form.platform = platform;
          const shopList = this.shopData.filter(
            (item) => item.platform == platform
          );
          if (shopList.length) {
            const shop = shopList[0].value;
            this.form.sellerManageId = shop;
            this.shopList = shopList;
          }
        }
      }
      this.shopChange(this.form.sellerManageId);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  &-platform {
    width: 95px;
  }
  &-shop {
    width: 185px;
    margin-left: 10px;
  }
}
</style>